import { UseMutationResult } from '@tanstack/react-query';
import { DeleteDepartmentRequest } from 'compliance-api/generated.ts';
import { FormikErrors, FormikValues, useFormik } from 'formik';
import * as yup from 'yup';
import { BaseModalProps, Button, ModalContentWrapper } from 'ui';

type initialValuesType = {
  id: number;
  name: string;
};
const initialValues: initialValuesType = {
  id: 0,
  name: '',
};

const validationSchema = yup.object({
  id: yup
    .number()
    .required('id is required')
    .typeError('id is required')
    .moreThan(0, 'id value must be more than 0'),
});

export interface AddFormModalProps extends BaseModalProps {
  id: number;
  title: string;
  name: string;
  modalTitle?: string;
  mutation: ({
    setErrors,
    onSuccess,
  }: {
    setErrors?: (errors: FormikErrors<FormikValues>) => void;
    onSuccess?: () => void;
  }) => UseMutationResult<unknown, unknown, DeleteDepartmentRequest, unknown>;
  onSuccess?: () => void;
}

export const DeleteModal = ({
  modalTitle,
  open,
  onClose,
  id,
  title,
  mutation,
  name,
  onSuccess,
}: AddFormModalProps) => {
  const handleCloseModal = () => {
    formik.resetForm();
    onClose();
  };

  const handleFormSubmit = async (values: { id: number }) => {
    mutateAsync(values);
  };

  const formik = useFormik({
    initialValues: {
      ...initialValues,
      id: id,
    },
    validateOnChange: false,
    validateOnMount: false,
    validateOnBlur: false,
    validationSchema,
    enableReinitialize: true,
    onSubmit: async values => {
      await handleFormSubmit(values);
      handleCloseModal();
    },
  });

  const { mutateAsync, isLoading } = mutation({ setErrors: formik.setErrors, onSuccess });

  return (
    <ModalContentWrapper
      open={open}
      title={modalTitle || `Are you sure you want to delete the ${title} called "${name}"?`}
      onClose={onClose}
    >
      <div>
        <Button type="button" loading={isLoading} onClick={formik.submitForm}>
          Delete {title}
        </Button>
      </div>
    </ModalContentWrapper>
  );
};
